import React, { FC, useContext } from "react"
import { RetinaImage } from "components/views/atoms/images/RetinaImage"
import { Spacer } from "components/views/atoms/Atoms"
import { Body, BodySmall } from "components/views/atoms/Bodies"
import { TextLink } from "components/views/atoms/links/TextLink"
import { ButtonPrimary } from "components/views/atoms/buttons/ButtonPrimary"
import L10n from "lib/carrot-l10n"
import { PhoneNumberUpdateModalContext } from "components/views/account/phoneNumberUpdate/UpdatePhoneNumberModal"
import { H2 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const UpdatePhoneNumberCompletedStep: FC = () => {
  const { onFinish } = useContext(PhoneNumberUpdateModalContext)

  return (
    <div className="flex flex-column">
      <div className="self-center">
        <RetinaImage name="illo-clipboard" width={160} height={160} />
      </div>
      <Spacer height={2} />
      <H2>{l`Phone number verified & updated`}</H2>
      <Spacer height={0.25} />
      <Body color="black-80">
        {l`This info is used to contact you via SMS if there’s an issue with
         your Carrot card, and is never shared with third parties.`}
      </Body>
      <br />
      <BodySmall color="black-60">
        {l`Questions or concerns?`} &nbsp;
        <TextLink>{l`Contact the Carrot Care Team`}</TextLink>
      </BodySmall>
      <Spacer height={3} />
      <div className="self-end">
        <ButtonPrimary onClick={onFinish}>{l`Got it`}</ButtonPrimary>
      </div>
      <Spacer height={1.5} />
    </div>
  )
}

export { UpdatePhoneNumberCompletedStep }
